/**
 * Active Intl locale holder.
 *
 * Lives in `shared` (not `app`) so locale-aware formatters here can read the
 * current locale without importing the app-layer i18n module (which would
 * violate the Features → Components → Shared import direction).
 *
 * The i18n bootstrap (app layer) pushes the active Intl locale here whenever the
 * language changes. Defaults to US English until the first update.
 */

let activeIntlLocale = 'en-US';

export const setActiveIntlLocale = (locale: string): void => {
  activeIntlLocale = locale;
};

export const getActiveIntlLocale = (): string => activeIntlLocale;

/**
 * Active app locale (the BCP 47 i18n language code, e.g. `es-US`, `fr`) — as
 * opposed to the Intl/Luxon formatting locale above. Held here in `shared` so
 * the axios layer can stamp it onto API requests (`X-Donvio-Locale`) without
 * importing the app-layer i18n module. The i18n bootstrap pushes updates here
 * on every language change. Defaults to English until the first update.
 */
let activeAppLocale = 'en';

export const setActiveAppLocale = (locale: string): void => {
  activeAppLocale = locale;
};

export const getActiveAppLocale = (): string => activeAppLocale;
